<template>
	<div>
		<vs-card style="color: Red; margin-top: 100px !important;">
			Under Construction
		</vs-card>
	</div>
</template>

<script>
	import {mapActions} from 'vuex'
	export default {
		name: "UnderConstruction",
		created() {
			this.initialSetup();
		},
		methods: {
			...mapActions(["updateHideAll", "updateBackButton"]),
			initialSetup() {
				this.updateHideAll();
				this.updateBackButton(false);
			}
		}
	}
</script>
